<div class="row">
    <div class="col-6" *ngIf="showLoanFilter">
        <mat-form-field appearance="outline">
            <mat-label>Filter by Loan Application</mat-label>
            <mat-select (selectionChange)="filterByLoanId($event)" [value]="{
                                    loanInfo: {
                                        loanNumber: 'View All Loans'
                                    }
                                }">
                <ng-container *ngFor="let loanAppItem of (loanApplications$ | async)">
                    <mat-option [value]="loanAppItem">
                        {{loanAppItem?.loanInfo?.loanNumber ?
                        loanAppItem?.loanInfo?.loanNumber :
                        'Pending - ' + loanAppItem?.loanInfo?.purpose?.name + ', ' +
                        loanAppItem?.loanInfo?.subjectPropertyAddress?.state}}
                    </mat-option>
                </ng-container>
            </mat-select>
        </mat-form-field>
    </div>
    <div class="col-6">
        <mat-checkbox [formControl]="viewArchivedLoansCtrl">View Archived Loans</mat-checkbox> &nbsp;
    </div>
    <div class="info-container" style="display: flex; flex-direction: row;" *ngIf="!lgvPricingService.isLockRequestAllowed()">
        <div>
            <h5>
                <fa-icon style="color:#FF9B06" icon="triangle-exclamation"> </fa-icon> &nbsp; Lock Request Unavailable
            </h5>
            <p>The market is closed and lock requests cannot be submitted at this time. The loan quotes will show updated
                pricing
                when
                the market reopens after 9:30am EST.</p>
                <p>{{ currentDate | date: 'M/d/y h:mm a'}}</p>
        </div>
        <!-- <div style="align-self: center; margin-left: auto;">
            <button class="btn btn-outline" style="padding: 10px 15px;" (click)="lgvPricingSvc.notifyFoLockRequest()">
                <fa-icon icon="bell-ring"> </fa-icon>Notify Me
            </button>
        </div> -->
    </div>
    <div class="Vert-20"></div>
</div>

<!--loop through scenarios-->
<ng-container *ngIf="(filteredPricingScenarios$ | async)?.length > 0; else noScenarios">
    <ng-container *ngFor="let scenario of filteredPricingScenarios$ | async">
        <ng-container *ngIf="viewArchivedLoansCtrl?.value || (scenario?.status?.name != 'Archived')">
            <ng-container *ngIf="{prop: lgvClientSvc.propertyForScenario(scenario?.id)} as propObj">

                <!--scenario info-->
                <!--we do not show pre-approved pricing w/o quotes (deal desk) in client side. so we hide it if request is null-->
                <ng-container *ngIf="scenario?.request">
                    <div class="row">
                        <div class="col-12 Vert-25"></div>
                        <div class="col-12">
                            <div style="display: flex;">
                                <h5>{{scenario.name}}</h5>
                                <span> &nbsp;
                                    {{scenario?.notes}}
                                </span>
                                <lgv-pricing-status-pill [pricingStatus]="scenario?.status"></lgv-pricing-status-pill>
                            </div>
                            <p>
                                <ng-container *ngIf="scenario?.loanApplicationId">
                                    Loan Application: <span style="color: #4A2F89; font-weight: 700; font-size: 16px;">
                                        {{scenario?.loanNumber ? scenario?.loanNumber : 'Pending'}} &nbsp;
                                    </span>
                                </ng-container>
                                <ng-container *ngIf="propObj.prop as prop">
                                    Property <span style="font-weight: 700;">
                                        {{prop.propertyInfo.address}} {{prop.propertyInfo.city}}
                                        {{prop.propertyInfo.state}}
                                        {{prop.propertyInfo.zip}}
                                    </span>
                                </ng-container>
                            </p>

                            <!--refi scenario-->
                            <div class="scenario-details" *ngIf="lgvClientSvc.isRefiScenario(scenario)">
                                <ng-container *ngIf="propObj.prop as prop">
                                    <ng-container *ngIf="getLoanForProperty(prop) as loan">
                                        <div class="column">
                                            <div class="value"><strong>${{prop.propertyInfo.avmestimatedValue |
                                                    number: '1.0-0'}}</strong></div>
                                            <div class="prop-label">Current Value</div>
                                        </div>

                                        <div class="column">
                                            <div class="value"><strong>${{loan.loanAnalysis.estimatedBalance |
                                                    number: '1.0-0'}}</strong></div>
                                            <div class="prop-label">Remaining Balance</div>
                                        </div>

                                        <div class="column">
                                            <div class="value"><strong>${{loan.loanInfo.monthlyPayment | number:
                                                    '1.0-0'}}</strong></div>
                                            <div class="prop-label">Current Mo. Payment</div>
                                        </div>

                                        <div class="column last">
                                            <div class="value"><strong>${{loan.loanInfo.interestRate | number :
                                                    '1.3-3'}}%</strong></div>
                                            <div class="prop-label">Current Rate</div>
                                        </div>
                                    </ng-container>
                                </ng-container>
                            </div>

                            <!--purchase scenario-->
                            <div class="scenario-details" *ngIf="!lgvClientSvc.isRefiScenario(scenario)">

                                <div class="column">
                                    <div class="value">
                                        <strong>${{scenario?.request?.propertyInformation?.salesPrice
                                            | number: '1.0-0'}}</strong>
                                    </div>
                                    <div class="prop-label">Purchase Price</div>
                                </div>

                                <div class="column">
                                    <div class="value">
                                        <strong>
                                            ${{downPaymentAmt(scenario) | number: '1.0-0'}}
                                            <span
                                                *ngIf="scenario?.request?.propertyInformation?.appraisedValue && scenario?.request.loanInformation?.baseLoanAmount && scenario?.request.loanInformation?.baseLoanAmount > 0">
                                                | {{downPaymentPct(scenario) | number : '1.0-0'}}%
                                            </span>
                                        </strong>
                                    </div>
                                    <div class="prop-label">Down Payment</div>
                                </div>

                                <div class="column">
                                    <div class="value">
                                        <strong>{{scenario?.request?.borrowerInformation?.fico}}</strong>
                                    </div>
                                    <div class="prop-label">FICO</div>
                                </div>

                                <div class="column last">
                                    <div class="value">
                                        <strong>{{scenario?.request?.borrowerInformation?.debtToIncomeRatio |
                                            number: '1.0-0'}}%</strong>
                                    </div>
                                    <div class="prop-label">DTI</div>
                                </div>

                            </div>
                        </div>
                    </div>

                    <!--loop through opportunities-->
                    <ng-container *ngFor="let o of lgvClientSvc.opportunitiesForThisScenario(scenario.id)">
                        <ng-container>
                            <lgv-opportunity-display [opportunity]="o" [scenario]="scenario"
                                (quoteLocked)="refreshScenarios($event)"
                                [property]="propObj?.prop"></lgv-opportunity-display>
                        </ng-container>

                    </ng-container>

                    <div class="Vert-20"></div>
                    <div style="border: 2px solid #A7A7A7;"></div>
                </ng-container>


            </ng-container>
        </ng-container>
    </ng-container>
</ng-container>
<ng-template #noScenarios>
    <br>
    <p style="margin-bottom: 300px;">There are no pricing quotes for this loan. View locked information are in the loan details tab.</p>
</ng-template>

<!-- <div class="row disclaimer-pricing">
    <p>Rates, terms and conditions are subject to change and may vary based on creditworthiness, qualifications, and collateral
    conditions. Credit is not guaranteed and will be contingent upon the loan amount and loan program. Borrowers are subject
    to credit approval. Other restrictions may apply.</p>
    
    <p>Loan data provided by Real-Finity Mortgage LLC. The actual payment obligation will be greater if taxes and insurance are
    included. Talk with your loan officer about how this might impact the monthly payment. Rates, terms, and conditions are
    subject to change and may vary based on creditworthiness, qualifications, and collateral conditions.</p>
    
    <p>This communication is provided to you for informational purposes only and should not be relied upon by you.
    Contact Real-Finity Mortgage LLC directly to learn more about its mortgage products and your eligibility for such
    products. The mortgage program information is not to be construed as a quotation or offer of credit from any lending
    institution. Programs, rates, terms, and conditions are subject to change at any time without notice. Actual rates
    available to you may vary based upon a number of factors including your credit rating, documentation level, appraisal,
    and market conditions. Other restrictions may apply.</p>
</div> -->